interface PopInfo {
  title: string,
  introduction: string,
  tableInfos: []
}

interface State {
  ncpLayerIsShow: boolean,
  ncpLayerIsExist: boolean,
  popInfo: PopInfo
}

const emptyInfo: PopInfo = {
  title: '',
  introduction: '',
  tableInfos: []
}

export default {
  namespaced: true,
  state: {
    ncpLayerIsShow: false,
    ncpLayerIsExist: false,
    popInfo: {
      ...emptyInfo
    }
  },
  mutations: {
    SET_NCPLAYERISSHOW(state: State, isShow: boolean): void {
      state.ncpLayerIsShow = isShow;
    },
    SET_NCPLAYERISEXIST(state: State, isExist: boolean): void {
      state.ncpLayerIsExist = isExist;
    },
    SET_POPINFO(state: State, popInfo: {}): void {
      state.popInfo = Object.assign({}, { ...popInfo }) as PopInfo;
    }
  },
  getters: {
    getNcpLayerIsShow(state: State): boolean {
      return state.ncpLayerIsShow;
    },
    getNcpLayerIsExist(state: State): boolean {
      return state.ncpLayerIsExist;
    },
    getNcpLayerInfo(state: State): {} {
      return state.popInfo;
    }
  }
};
